export default {
  talk_to_us: 'Sprich mit uns:',
  send_us_email: 'Sende uns eine E-Mail:',
  visit_website: 'Besuche unsere Website:',
  join_our_community: 'Tritt unserer Gemeinschaft bei für exklusive Angebote und Updates!',
};
